import ArticleContentContainer from './ArticleContentContainer';

export default ArticleContentContainer;
